<onsip-list-picker-view
  [itemNamePlural]="'ONSIP_I18N.REPS' | translate"
  [itemList]="(repListItems | async) || []"
></onsip-list-picker-view>
